<template>
  <div
    class="template-wrap so-week-event-template"
    v-bind:style="{
      'background-color':
        data.WOType === 'Maintenance' ? 'gray' : data.TransportStatusHexColour,
    }"
  >
    <div class="main_subject">
      <div class="group-1">
        <span>{{ data.subject }}</span>
      </div>
      <span>{{ data.WorkOrderFriendlyStatus }}</span>
    </div>

    <div class="subject">
      <span>SO # {{ data.SalesOrderCode }}</span>
      <span>{{ data.TransportStatus }}</span>
    </div>
    <div class="customer">
      <span>{{ data.CustomerName }}</span>
      <span>{{ getFormattedDate(data.SalesOrderShipDate) }}</span>
    </div>
    <div class="data">
      <div class="planned">
        <span>
          {{ data.ProductCode }}
        </span>
      </div>
      <div class="actual">
        <div class="actual-items">
          <span>Ordered</span>&nbsp;
          <span>
            {{ getFormattedQty(data.SalesOrderStockUMQuantity) }}
            {{ data.StockUM }}
          </span>
        </div>
        <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";
export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    getFormattedDate(value) {
      return new Date(value).toShortDateString();
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .so-week-event-template {
    padding: 5px 5px;

    .main_subject {
      border-bottom: 2px solid;
      margin-bottom: 2px;
      padding-bottom: 1px;
    }
    .main_subject,
    .subject,
    .customer {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }
    .main_subject,
    .subject,
    .customer {
      > span {
        font-size: 10px;
      }
    }

    .description {
      font-size: 12px;

      span:last-child {
        text-wrap: wrap;
      }
    }

    .data {
      font-size: 10px;
      display: flex;
      justify-content: space-between;
      // .planned {
      //   padding-right: 25px;
      // }

      .actual {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }

    @media screen and (max-width: 1750px) {
      .data {
        flex-direction: column;
        .actual {
          flex-direction: unset;
        }
      }
    }
  }
}
</style>
